import { Box, Typography, Button, useMediaQuery, SxProps, Theme } from "@mui/material";
import iconDownload from "@assets/img/icon_donwload.svg";

interface ButtonDownloadTablaAmortizacionProps {
  sx?: SxProps<Theme>;
  disabled: boolean;
  onClick: () => void;
}

const ButtonDownloadTablaAmortizacion = ({ sx, disabled, onClick }: ButtonDownloadTablaAmortizacionProps) => {
  const isMobileOrTablet = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  return (
    <Box display="flex" flexDirection="column" alignItems="center" sx={sx}>
      <Button variant="text" type="button" onClick={onClick} disabled={disabled}>
        <Typography
          variant={isMobileOrTablet ? "body2" : "body1"}
          color={disabled ? "text.disabled" : "primary.dark"}
          align="center"
        >
          <img src={iconDownload} alt="" /> Descarga aquí tu tabla de amortización
        </Typography>
      </Button>
    </Box>
  );
};

export default ButtonDownloadTablaAmortizacion;
